import { isEqual } from 'lodash-es';

import type { QuickFilter } from './lib/filter-utils.ts';
import { QuickFilterButton } from './quick-filter-button.tsx';

type Props<T> = {
    quickFilters: QuickFilter<T>[];
    currentlyActiveFilters: T;
    onApplyQuickFilter: (filter: T) => void;
};

function quickFilterIsMatchedToCurrentFilters<T>(
    selectedQuickFilter: QuickFilter<T>,
    currentlyActiveFilters: T,
): boolean {
    return isEqual(selectedQuickFilter.filter, currentlyActiveFilters);
}

export function QuickFilterList<T>({ quickFilters, currentlyActiveFilters, onApplyQuickFilter }: Props<T>) {
    const selectedQuickFilter = quickFilters.find((quickFilter) =>
        quickFilterIsMatchedToCurrentFilters(quickFilter, currentlyActiveFilters),
    );

    return (
        <div className="flex items-center gap-3">
            {quickFilters
                .filter(({ showByDefault = true }) => showByDefault)
                .map((quickFilter) => {
                    return (
                        <QuickFilterButton
                            key={quickFilter.id}
                            onClick={() => {
                                onApplyQuickFilter(quickFilter.filter);
                            }}
                            isSelected={selectedQuickFilter?.id === quickFilter.id}
                        >
                            {quickFilter.label}
                        </QuickFilterButton>
                    );
                })}
        </div>
    );
}
